export interface PasswordStrength {
  length: boolean;
  letter: boolean;
  number: boolean;
  symbol: boolean;
  isValid: boolean;
}

export const getPasswordStrength = (password: string): PasswordStrength => {
  const length = password.length >= 8;
  const letter = /[a-zA-Z]/.test(password);
  const number = /\d/.test(password);
  const symbol = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  const conditionsMet = [letter, number, symbol].filter(Boolean).length;

  return {
    length,
    letter,
    number,
    symbol,
    isValid: length && conditionsMet >= 2,
  };
};
